import { isDefinedObject, isTruthy } from 'notable-common';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
/** The values Flow Studio writes to a Start block's `entityType`; `None` means the flow has no entity. */
export var FlowStartEntityType;
(function (FlowStartEntityType) {
    FlowStartEntityType["Patient"] = "Patient";
    FlowStartEntityType["Encounter"] = "Encounter";
    FlowStartEntityType["Order"] = "Order";
    FlowStartEntityType["ExternalDocumentPacket"] = "ExternalDocumentPacket";
    FlowStartEntityType["None"] = "None";
})(FlowStartEntityType || (FlowStartEntityType = {}));
export var TestRunEntitySourceVariant;
(function (TestRunEntitySourceVariant) {
    TestRunEntitySourceVariant["Production"] = "Production";
    TestRunEntitySourceVariant["Test"] = "Test";
})(TestRunEntitySourceVariant || (TestRunEntitySourceVariant = {}));
/** Where a test run's `{{inputs.*}}` values come from. Production runs always use CallerDefined. */
export var FlowStartInputMode;
(function (FlowStartInputMode) {
    /** Test runs inject the Start block's `mockInputs` JSON. */
    FlowStartInputMode["Mocked"] = "Mocked";
    /** Test runs use whatever startData the caller supplied, same as production. */
    FlowStartInputMode["CallerDefined"] = "CallerDefined";
})(FlowStartInputMode || (FlowStartInputMode = {}));
export const FlowStartBlockConfigSchema = z.object({
    isStartBlock: z.literal(true),
    entityType: z.string().optional(),
    // TODO: the testEntity doesn't really belong here. This is a property of a test run, not of a flow
    testEntityId: z.uuid().optional(),
    testPracticeId: z.uuid().optional(),
    testRunEntitySourceVariant: z.enum(TestRunEntitySourceVariant).optional(),
    // Mock inputs for test runs; JSON-encoded object, injected as {{inputs.<key>}}. See buildMockInputsStartData.
    inputMode: z.enum(FlowStartInputMode).optional(),
    mockInputs: z
        .string()
        .optional()
        .refine((value) => {
        const trimmed = value?.trim();
        if (!isTruthy(trimmed)) {
            return true;
        }
        // Avoid parsing large payloads; a shape check on the delimiters is enough here.
        if (trimmed.length > 1_000) {
            return trimmed.startsWith('{') && trimmed.endsWith('}');
        }
        try {
            const parsed = JSON.parse(trimmed);
            return isDefinedObject(parsed) && !Array.isArray(parsed);
        }
        catch {
            return false;
        }
    }, { message: 'mockInputs must be a JSON object' }),
});
export const FlowStartBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Start),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Start),
    config: FlowStartBlockConfigSchema,
});
//# sourceMappingURL=config.js.map